import { render, staticRenderFns } from "./SanctionNotification.vue?vue&type=template&id=84fe8198&scoped=true"
import script from "./SanctionNotification.vue?vue&type=script&lang=js"
export * from "./SanctionNotification.vue?vue&type=script&lang=js"
import style0 from "./SanctionNotification.vue?vue&type=style&index=0&id=84fe8198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fe8198",
  null
  
)

export default component.exports